// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__r9jAe","buttons":"SendReceipts_buttons__3JahC","email":"SendReceipts_email__2QnrR","bookApptTitle":"SendReceipts_bookApptTitle__EQvPI"};